var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z",
    fill: "#E50B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4749 29.4749C72.8417 28.108 72.8417 25.892 71.4749 24.5251C70.108 23.1583 67.892 23.1583 66.5251 24.5251L48 43.0503L29.4749 24.5251C28.108 23.1583 25.892 23.1583 24.5251 24.5251C23.1583 25.892 23.1583 28.108 24.5251 29.4749L43.0503 48L24.5251 66.5251C23.1583 67.892 23.1583 70.108 24.5251 71.4749C25.892 72.8417 28.108 72.8417 29.4749 71.4749L48 52.9497L66.5251 71.4749C67.892 72.8417 70.108 72.8417 71.4749 71.4749C72.8417 70.108 72.8417 67.892 71.4749 66.5251L52.9497 48L71.4749 29.4749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconDark);
export default __webpack_public_path__ + "static/media/delete-icon-dark.3a6b1a8b06382773fdb531b55634392d.svg";
export { ForwardRef as ReactComponent };